import type { Chain } from '../../../chain';
import type {
  BaseNetworkProvider,
  NetworkData,
} from '../networkProvider/networkProvider.types';

export const createBaseNetworkProvider = <TChain extends Chain = Chain>(
  chain: TChain,
  networkData: NetworkData
): Omit<BaseNetworkProvider<TChain>, 'getBalance'> => ({
  blockExplorerUrls: networkData.blockExplorerUrls,
  chain,
  displayName: networkData.displayName,
  iconUrl: networkData.iconUrl,
  id: `${chain}-${networkData.networkId}`,
  nativeCurrency: networkData.nativeCurrency,
  networkId: networkData.networkId,
  rpcUrls: networkData.rpcUrls,
  testnet: networkData.testnet,
});
